/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useState, useCallback, useMemo, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { IoMdArrowBack } from 'react-icons/io';
import { MdLocalPhone } from 'react-icons/md';
import { FiMail } from 'react-icons/fi';
import { Formik } from 'formik';
import * as Yup from 'yup';

import OutlinedButton from 'components/layout/form/outlinedButton';
import RadioFieldNew from 'components/layout/form/radioFieldNew';
import { useMFAContext } from 'hooks/useMFA';
import { arrUniqueContact } from 'utils/functions';
import { sendToken } from '../services';

import { HeaderContainer } from '../styles';
import {
  Container,
  ContainerButtons,
  FormContainer,
  RadioContent,
  Error,
  DescriptionWrap,
} from './styles';

const TypeToken = ({ setStep, userInfo, setUserInfo }) => {
  const [loading, setLoading] = useState();

  const { setAttempts, setCredentials } = useMFAContext();

  const history = useHistory();

  const contacts = useMemo(() => {
    if (userInfo?.contacts?.length === 0) return [];

    let contactsResponse = [];

    contactsResponse = userInfo?.contacts ?? [];

    if (contactsResponse && contactsResponse.length > 0) {
      contactsResponse = arrUniqueContact(contactsResponse);
    }

    return contactsResponse?.sort(function compare(a, b) {
      if (a.contactType < b.contactType) return 1;
      if (a.contactType > b.contactType) return -1;
      return 0;
    });
  }, [userInfo]);

  const handleSubmit = useCallback(
    async (values) => {
      if (!loading) {
        setLoading(true);
        const contact = userInfo?.contacts?.find(
          (item) => values?.type === item?.contactId
        );
        const success = await sendToken(contact, userInfo?.userId);
        if (success) {
          setStep(2);
          setUserInfo({ ...userInfo, validationContactId: contact?.contactId });
        }
        setLoading(false);
      }
    },
    [loading, userInfo, setStep, setUserInfo]
  );

  const validatorSchema = () =>
    Yup.object().shape({
      type: Yup.string().required('É necessário selecionar um tipo de token'),
    });

  const handleBack = () => {
    sessionStorage.removeItem('@UltragazEmpresarial:X-Mfa-Login');
    setAttempts(1);
    setCredentials({ login: '', password: '', token: '' });
    history.push('/');
  };

  const handleSelectContact = (contactId) => {
    const contact = userInfo?.contacts?.find(
      (item) => contactId === item?.contactId
    );
    sendToken(contact, userInfo?.userId).then((success) => {
      if (success) {
        setStep(2);
        setUserInfo({ ...userInfo, validationContactId: contact?.contactId });
      }
    });
  };

  return (
    <Container>
      <HeaderContainer>
        <h1>Duplo fator de Autenticação</h1>
        <h2>Selecione um contato para receber o código</h2>
      </HeaderContainer>

      <Formik
        initialValues={{ type: '' }}
        validationSchema={validatorSchema}
        onSubmit={handleSubmit}
      >
        {({ handleChange, handleBlur, values, errors, touched }) => (
          <FormContainer>
            {contacts.map((contact) => (
              <Fragment key={contact?.contactId}>
                <RadioContent active={values.type === contact?.contactId}>
                  <RadioFieldNew
                    id={contact?.contactId}
                    type="radio"
                    name="type"
                    value={contact?.contactId}
                    defaultChecked={values.type === contact?.contactId}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      handleSelectContact(contact?.contactId);
                    }}
                  >
                    <div>
                      {contact?.contactType === 'PHONE' ? (
                        <MdLocalPhone />
                      ) : (
                        <FiMail />
                      )}
                      <DescriptionWrap>
                        <span>Via</span>
                        <span>
                          {contact?.contactType === 'PHONE' ? 'SMS' : 'email'}
                        </span>
                      </DescriptionWrap>
                    </div>
                    <span>{contact?.contact}</span>
                  </RadioFieldNew>
                </RadioContent>
              </Fragment>
            ))}

            {errors.type && touched.type && <Error>{errors.type}</Error>}

            <ContainerButtons>
              <OutlinedButton
                width="100%"
                LeadingIcon={() => <IoMdArrowBack size={20} />}
                onClick={handleBack}
              >
                Voltar
              </OutlinedButton>
            </ContainerButtons>
          </FormContainer>
        )}
      </Formik>
    </Container>
  );
};

export default TypeToken;
